export { default } from './ValidPaymentMethods';
